import { Component, ElementRef, viewChild } from '@angular/core';

/**
 * The row of product cards that used to be slick's `slick2`: four across on a desktop, fewer as
 * the viewport narrows, with an arrow at each end.
 *
 * <p>slick built this by cloning the slides for its infinite scroll and moving every one of them
 * into a track it rebuilt on each resize. That is DOM Angular had rendered on the server and
 * expected to still be there, so hydration broke on it. The row is now an ordinary horizontal
 * scroller: CSS scroll snapping does the paging and the arrows only call `scrollBy`. With no
 * JavaScript at all it degrades to a row you can still swipe, rather than to a broken one.
 *
 * <p>The slide widths live in override.css, because the breakpoints have to match the theme's.
 */
@Component({
  selector: 'product-slider',
  host: {
    style: 'display: contents'
  },
  template: `
    <div class="wrap-slick2">
      <div #track class="slick2">
        <ng-content />
      </div>
      <button class="arrow-slick2 prev-slick2" type="button" aria-label="Попередні товари"
        (click)="page(-1)">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </button>
      <button class="arrow-slick2 next-slick2" type="button" aria-label="Наступні товари"
        (click)="page(1)">
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </button>
    </div>
    `
})
export class ProductSliderComponent {

  private track = viewChild.required<ElementRef<HTMLElement>>('track');

  /** One arrow press moves a full screenful, which is what `slidesToScroll` amounted to. */
  page(direction: number): void {
    const element = this.track().nativeElement;
    element.scrollBy({ left: direction * element.clientWidth, behavior: 'smooth' });
  }

}
